<form class="content-card">
  <div class="row align-items-center">
    <div class="col-md-7 col-sm-12">
      <app-agreement-picker [agreements]="agreements()"
        (agreementSelectionChange)="onAgreementSelection($event)">
      </app-agreement-picker>
    </div>
    @if (workerAgreement) {
    <div class="col-md-5 col-sm-12 agreement-meta">
      <span class="agreement-meta__item">
        <strong>{{ 'Absences.Profile.WorkingTime' | translate }}:</strong> {{ displayedWorkingTime() }}
      </span>
      <span class="agreement-meta__item">
        <strong>{{ 'Absences.Profile.AgreementStatus' | translate }}:</strong> {{ workerAgreement.AgreementStatus }}
      </span>
    </div>
    }
  </div>
  @if (workerAgreement && isScaled()) {
  <div class="row">
    <div class="col-md-7 col-sm-12">
      <app-working-time-period-picker [periods]="workingTimePeriods()!.Periods"
        [(periodSelection)]="selectedPeriod">
      </app-working-time-period-picker>
    </div>
  </div>
  }
  @if (workingTimePeriodsLoading()) {
  <alert message="Absences.ABS-LoadingWorkingTimePeriods" alertType="info"></alert>
  } @else if (isScaled() && !selectedPeriod()) {
  <alert message="Absences.ABS-SelectWorkingTimePeriod" alertType="info"></alert>
  }
  @if (workerAgreement?.HasAbsences) {
  <div class="row">
    <div class="col-md-12 col-sm-12 text-right">
      <button mat-raised-button color="accent" *ifHasPermissions="['ViewWorkerAbsences', 'Supervisor']"
        [disabled]="!workerAgreement || isRefreshRequestInProgress()" (click)="refreshAbsences(workerAgreement)">
        {{ 'RefreshAbsences' | translate }}
      </button>
      <button mat-raised-button color="primary" class="ml-2" [disabled]="!canCreateAbsence()" (click)="openAbsenceModal()">
        {{ 'CreateAbsence' | translate }}
      </button>
    </div>
  </div>
  }
</form>
@if (workerAgreement; as agreement) {
@if (showPartTimeInfo()) {
<div class="part-time-info">
  <mat-icon class="part-time-info__icon">info</mat-icon>
  <span>{{ 'Absences.Profile.PartTimeInfo' | translate }}</span>
</div>
}
}
<mat-tab-group (selectedTabChange)="onTabChanged($event)">
  @if (workerAgreement?.HasAbsences) {
  <mat-tab [label]="'WorkerAbsenceLimitsTab' | translate">
    <app-worker-absence-limits-list [workerAgreementId]="workerAgreement?.Id"></app-worker-absence-limits-list>
  </mat-tab>

  <mat-tab [label]="'WorkerAbsenceListTab' | translate">
    <app-worker-absences-list [workerAgreementId]="workerAgreement?.Id" [year]="selectedYear"
      [workingTimePeriods]="workingTimePeriods()"
      (yearChange)="onYearChange($event)"></app-worker-absences-list>
  </mat-tab>
  }
  @if (workerAgreement?.HasSickLeaves) {
  <mat-tab [label]="'WorkerIllnessTab' | translate">
    <app-worker-illness-list
      [workerAgreementId]="workerAgreement?.Id"></app-worker-illness-list></mat-tab>
  }
</mat-tab-group>